import { APIManagementSection } from 'src/v2/components/LeftSidePanel/components/APIManagementSection';
import { AddOnGoBackButton } from '../AddOnGoBackButton';
import styles from './AddOnPanel.module.scss';

export const AddOnPanel = () => {
  return (
    <div className={styles.root}>
      <AddOnGoBackButton />

      <APIManagementSection />
    </div>
  );
};
